// extracted by mini-css-extract-plugin
export var innerBox = "ProjectCard-module--inner-box--f8c1b";
export var innerContent = "ProjectCard-module--inner-content--c6fb1";
export var innerSub = "ProjectCard-module--inner-sub--349b5";
export var innerTitle = "ProjectCard-module--inner-title--c8804";
export var projectValue = "ProjectCard-module--project-value--004ce";
export var splideSlide = "ProjectCard-module--splide-slide--5118b";
export var sponsors = "ProjectCard-module--sponsors--b4d39";
export var value = "ProjectCard-module--value--da4ec";